export enum UserAgentEnum {
  Crios = 'crios',
  Chrome = 'chrome',
  Firefox = 'firefox'
}
